"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogInformationContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.DialogInformationContainer = styled_components_1.default.div `
  ${props => props.message
    ? ""
    : `
  background: white;
  border: 1px solid #a2adb8;
  padding: 5px;
  `};

  white-space: pre-wrap;
  text-align: left;
`;
//# sourceMappingURL=dialog-information-container.js.map